import { TranslationFunction } from '@/i18n/types'
import * as z from 'zod'

export const getBookFormValidation = (t: TranslationFunction) => {
  const schema = z
    .object({
      countryId: z
        .string()
        .min(1, t('validation.countryReq'))
        .or(z.number().min(1, t('validation.countryReq'))),
      fromPointName: z.string().min(1, t('validation.fromReq')),
      fromPointLat: z.string(),
      fromPointLong: z.string(),
      fromPointDetails: z.string().optional(),
      fromPointPlaceId: z.string().optional(),
      fromPointTypes: z.string().optional(),
      toPointName: z.string().min(1, t('validation.toReq')),
      toPointLat: z.string(),
      toPointLong: z.string(),
      toPointDetails: z.string().optional(),
      toPointPlaceId: z.string().optional(),
      toPointTypes: z.string().optional(),
      date: z.any().refine(
        v => {
          const date = v instanceof Date ? v : new Date(v)
          return Boolean(date)
        },
        {
          message: t('validation.dateReq'),
        },
      ),
      time: z.any({ message: t('validation.timeReq') }),
      passengers: z
        .number()
        .min(1, t('validation.passMin'))
        .max(100, t('validation.passMax')),
      checkedLuggage: z
        .number()
        .min(0, t('validation.positive'))
        .max(100, t('validation.luggageMax')),
      handLuggage: z
        .number()
        .min(0, t('validation.positive'))
        .max(100, t('validation.luggageMax')),

      addChildSeats: z.boolean(),
      carrier: z.number().min(0, t('validation.positive')),
      childSeats: z.number().min(0, t('validation.positive')),
      booster: z.number().min(0, t('validation.positive')),
    })
    .refine(
      v =>
        v.fromPointLat.toString() !== '0' &&
        v.fromPointLong.toString() !== '0' && {
          message: t('validation.fromReq'),
          path: ['fromPointName'],
        },
    )
    .refine(
      v =>
        v.toPointLat.toString() !== '0' &&
        v.toPointLong.toString() !== '0' && {
          message: t('validation.toReq'),
          path: ['toPointName'],
        },
    )
    .refine(v => v.fromPointName !== v.toPointName, {
      message: t('validation.sameLocErr'),
      path: ['toPointName'],
    })
    .refine(v => v.passengers > v.childSeats + v.booster + v.carrier, {
      message: t('validation.seatsExceedErr'),
      path: ['passengers'],
    })
  return { schema }
}
